export * from './wizard.component';
export * from './wizard.tab';
export * from './wizard.content';
export * from './wizard.prev';
export * from './wizard.next';
export * from './wizard.tab.lifecycle';

import {Wizard} from './wizard.component';
import {WizardTab} from './wizard.tab';
import {WizardContent} from './wizard.content';
import {WizardPrev} from './wizard.prev';
import {WizardNext} from './wizard.next';
import {WizardOnTabActive} from './wizard.tab.lifecycle';

export const WIZARD_COMPONENTS = [
    Wizard,
    WizardTab,
    WizardContent,
    WizardPrev,
    WizardNext,
    WizardOnTabActive
];

export const WIZARD_PROVIDERS = [];


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/wizard/index.ts